import React, { useContext, useEffect, useState } from 'react'
import './styles.css'
import { AuthContext } from '../../contexts/auth'
import { Link } from 'react-router-dom'

export const NavBar = () => {
	const { logout } = useContext(AuthContext)
	const [username, setUsername] = useState('')

	useEffect(() => {
		const cUserName = localStorage.getItem('user')
		if (cUserName) {
			setUsername(JSON.parse(cUserName).name)
		}
	}, [])

	return (
		<nav id="navBar" className="hide">
			<Link to="/user" className="link-meu-perfil nav-btns">
				<span className="user-icon material-symbols-outlined">account_circle</span>
				<h1 className="nav-title labels">{username}</h1>
				<span className="user-subtitle">Minha Conta</span>
			</Link>
			<Link className="nav-btns" to="/home">
				<span className="material-symbols-outlined">home</span>
				<label id="btn-home" className="labels">
					Início
				</label>
			</Link>
			<Link className="nav-btns" to="/contracts">
				<span className="material-symbols-outlined">library_books </span>
				<label id="btn-activities" className="labels">
					Contratos
				</label>
			</Link>
			<Link className="nav-btns" to="/tasks">
				<span className="material-symbols-outlined">view_list</span>
				<label id="btn-activities" className="labels">
					Acompanhar Atividades
				</label>
			</Link>
			<Link className="nav-btns" to="/order">
				<span className="material-symbols-outlined">add_task</span>
				<label id="btn-tasks" className="labels">
					Nova Demanda
				</label>
			</Link>
			<Link className="nav-btns" to="/chat">
				<span className="material-symbols-outlined">headset_mic</span>
				<label id="btn-contact" className="labels">
					Fale Conosco
				</label>
			</Link>
			<Link className="nav-btns" to="/login">
				<span className="material-symbols-outlined">logout</span>
				<label id="logout" className="labels" onClick={logout}>
					Desconectar
				</label>
			</Link>
		</nav>
	)
}
